/**
 * @desc 绑定接口，主表格会拿视图接口，副表格会直接设置
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.ViewTableBindRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/viewTable/bind`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
